





function enableVariantLabelUpdate(context = document) {
  context.querySelectorAll('.option-selector.variant--color').forEach(function(fieldset) {
    var labelSpan = fieldset.querySelector('[id^="current-color-"]');
    if (!labelSpan) return;

    fieldset.querySelectorAll('input[type=radio]').forEach(function(input) {
      input.addEventListener('change', function() {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        var text = "";
        var fallback = label ? label.querySelector('.text-fallback') : null;

        if (fallback) {
          text = fallback.textContent;
        } else {
          var vis = label ? label.querySelector('span:not(.visually-hidden)') : null;
          if (vis) text = vis.textContent;
        }

        if (!text) text = input.value;

        // ✂️ Обрезаем до 20 символов с троеточием
        text = text.trim();
        if (text.length > 25) {
          text = text.slice(0, 25) + '...';
        }

        labelSpan.textContent = text;
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  enableVariantLabelUpdate();
});

const drawer = document.querySelector('.quick-add__product-details');
if (drawer) {
  const observer = new MutationObserver(function() {
    enableVariantLabelUpdate(drawer);
  });
  observer.observe(drawer, { childList: true, subtree: true });
}








document.addEventListener('DOMContentLoaded', function() {
  const viewport = document.querySelector('meta[name="viewport"]');
  const key = 'userZoomDetected';

  if (!viewport) return;

  let userZoom = sessionStorage.getItem(key) === 'true';

  // Функция применяет автоматическую подгонку
  function applyAutoFit() {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1');
  }

  // Если пользователь не зумил, применяем автоподгонку
  if (!userZoom) {
    applyAutoFit();
  }

  // Слушаем жест зума — разрешаем пользователю управлять
  const handleUserZoom = () => {
    userZoom = true;
    sessionStorage.setItem(key, 'true');
    window.removeEventListener('gesturestart', handleUserZoom);
  };
  window.addEventListener('gesturestart', handleUserZoom);

  // Слушаем изменения размера окна (например, появление скелетона увеличивает ширину)
  window.addEventListener('resize', () => {
    if (!userZoom) {
      applyAutoFit();
    }
  });

  // Опционально — отслеживаем изменения в DOM (например, подгрузка скелетона)
  const observer = new MutationObserver(() => {
    if (!userZoom) {
      applyAutoFit();
    }
  });

  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });

  // Сброс на переходе со страницы
  window.addEventListener('beforeunload', () => {
    sessionStorage.removeItem(key);
    observer.disconnect();
  });
});





document.addEventListener('DOMContentLoaded', () => {
  const stickyBlock = document.querySelector('.product-info--sticky');
  if (!stickyBlock) return;

  let lastScroll = window.scrollY;

  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;

    if (currentScroll > lastScroll) {
      // Скролл вниз — ничего не меняем, просто оставляем
      stickyBlock.style.transition = 'top 0.3s ease';
    } else {
      // Скролл вверх — тоже самое, просто плавность
      stickyBlock.style.transition = 'top 0.3s ease';
    }

    lastScroll = currentScroll;
  });
});




document.addEventListener("DOMContentLoaded", () => {
  const isMobile = window.innerWidth <= 768;
  const desktopWrapper = document.getElementById("collectionSearchBox");
  const desktopBtn = document.getElementById("toggleSearchBtn");
  const desktopInput = document.getElementById("collectionSearchInput");

  const mobileBlock = document.getElementById("mobileSearchBlock");
  const mobileInput = document.getElementById("mobileSearchInput");
  const searchResults = document.getElementById("customSearchResults");
  const loadMoreWrapper = document.getElementById("loadMoreWrapper");
  const loadMoreBtn = document.getElementById("loadMoreBtn");

  let currentQuery = "";
  let currentPage = 1;

  const lang = document.documentElement.lang || 'en';
  const translations = {
    ru: 'Показать ещё',
    fr: 'Afficher plus',
    nl: 'Meer weergeven',
    de: 'Mehr anzeigen',
    en: 'Show more'
  };
  const showMoreText = translations[lang] || translations.en;
  if (loadMoreBtn) loadMoreBtn.textContent = showMoreText;

  // 🔓 Открытие поиска
  if (desktopBtn) {
    desktopBtn.addEventListener("click", function () {
      if (isMobile && mobileBlock) {
        desktopBtn.style.display = 'none';
        mobileBlock.style.display = 'block';
        mobileInput.focus();
      } else {
        desktopWrapper.classList.toggle("expanded");
        if (desktopWrapper.classList.contains("expanded")) {
          desktopInput.focus();
        }
      }
    });
  }

  // 📦 Загрузка результатов
  function loadSearchResults(query, page = 1, append = false) {
    fetch(`/search?q=${encodeURIComponent(query)}&page=${page}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productItems = doc.querySelectorAll('li.js-pagination-result');

        const limit = isMobile ? 14 : 15;
        const limitedItems = Array.from(productItems).slice(0, limit);

        if (!append) {
          searchResults.innerHTML = `
            <h2 style="text-align:center;margin: -16px 0 10px; font-size: 20px;">
              🔍 ${lang === 'fr' ? 'Résultats pour vous' :
                 lang === 'nl' ? 'Zoekresultaten voor jou' :
                 lang === 'de' ? 'Suchergebnisse für dich' :
                 lang === 'ru' ? 'Результаты поиска для вас' :
                 'Search results for you'}
            </h2>
            <ul id="customCardWrapper" class="grid mb-8 md:mb-12 grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-theme gap-y-10" style="padding: 10px; box-sizing: border-box;"></ul>
          `;
        }

        const wrapper = document.getElementById("customCardWrapper");

        limitedItems.forEach(item => {
          // 🧼 Удаляем кнопку сравнения и label
          const compareBox = item.querySelector(".compare-checkbox");
          const compareLabel = item.querySelector("label[for^='compare-']");
          if (compareBox) compareBox.remove();
          if (compareLabel) compareLabel.remove();

          wrapper.appendChild(item);
        });

        const hasNext = !!doc.querySelector('.pagination__item--next');
        loadMoreWrapper.style.display = hasNext ? "block" : "none";
      })
      .catch(err => {
        console.error("Ошибка при загрузке поиска:", err);
      });
  }

  // 🔍 Реакция на ввод
  function handleInput(inputEl) {
    const query = inputEl.value.trim();
    if (!query) {
      searchResults.innerHTML = "";
      loadMoreWrapper.style.display = "none";
      return;
    }
    currentQuery = query;
    currentPage = 1;
    loadSearchResults(currentQuery, currentPage);
  }

  if (desktopInput) desktopInput.addEventListener("input", () => handleInput(desktopInput));
  if (mobileInput) mobileInput.addEventListener("input", () => handleInput(mobileInput));

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", () => {
      currentPage++;
      loadSearchResults(currentQuery, currentPage, true);
    });
  }
});


document.querySelectorAll('.card--product-contained, .recommended-card').forEach(card => {
  card.addEventListener('mouseleave', () => {
    card.classList.remove('bounce-back');
    void card.offsetWidth; // трюк для перезапуска анимации
    card.classList.add('bounce-back');

    setTimeout(() => {
      card.classList.remove('bounce-back');
    }, 400); // длительность bounceBack анимации
  });
});





